import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { APP_ENV } from '@utils/constants';
import { useBreakpointValue } from '@gemini/core';
let isScriptAppended = false;
const HeroSearchCard = () => {
    const slaLayout = useBreakpointValue({
        base: 'vertical',
        md: 'horizontal',
    });
    const addSingleLineAddressScript = () => {
        const script = document.createElement('script');
        script.src = `https://${APP_ENV === 'live' ? 'www' : APP_ENV}.immowelt.de/anbieten/immobilienbewertung/lp/valuation-range-single-line-address.js`;
        script.type = 'text/javascript';
        script.async = true;
        document.body.appendChild(script);
        script.onload = () => {
            window.customElements
                .whenDefined('valuation-range-single-line-address')
                .then(() => {
                isScriptAppended = true;
            });
        };
        return () => {
            document.body.removeChild(script);
            isScriptAppended = false;
        };
    };
    useEffect(() => {
        if (!isScriptAppended) {
            addSingleLineAddressScript();
        }
        return undefined;
    }, []);
    return (_jsx("valuation-range-single-line-address", { "no-floating-button": "true", "m-tracking": "seo_estimate_landing_housevaluation_online_price_calculator_estimate_step1", layout: slaLayout, target: "_self" }));
};
export default HeroSearchCard;
